module.exports = __webpack_public_path__ + "static/media/image.e900f53a.png";